import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import { useCategorySales } from "./hooks/useCategorySales";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

// const modalInfo = {
//   title: "categorySales.info.title",
//   rows: [
//     "categorySales.info.definition",
//     "categorySales.info.unitsUsed",
//     "categorySales.info.unitsSold",
//     "categorySales.info.subTotal",
//   ],
// };

const CategorySales = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useCategorySales(requestParams);

  const tableDataEmpty = !isLoading && !data?.reportData?.length;

  const tableData = useMemo(
    () =>
      data?.reportData.map((data) => ({
        category: data.category,
        unitsSold: data.unit_sold,
        subTotal: data.gross_sales,
        itemDiscount: data.discount_percentage,
        taxableAmount: data.taxable_amount,
      })),
    [data],
  );

  const clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  const totalDatas = [
    ...(tableData || []),
    !tableDataEmpty &&
      !isLoading && {
        category: <span className="bold">Total</span>,
        unitsSold: <span className="bold">{data.total.unit_sold}</span>,
        subTotal: <span className="bold">{data.total.gross_sales}</span>,
        itemDiscount: (
          <span className="bold">{data.total.discount_percentage}</span>
        ),
        taxableAmount: (
          <span className="bold">{data.total.taxable_amount}</span>
        ),
      },
  ].filter(Boolean);

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Category Sales"
        selectedClinic={selectedClinic}
        clinics={clinics}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getCategorySales()}
        requestParams={requestParams}
        // modalInfo={modalInfo}
      />
      <div className="flex gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Category", accessor: "category" },
              { data: "Units Sold", accessor: "unitsSold" },
              { data: "Sub-Total", accessor: "subTotal" },
              { data: "Item Discount", accessor: "itemDiscount" },
              { data: "Taxable Amount", accessor: "taxableAmount" },
            ]}
            data={totalDatas}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {tableDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategorySales;
